import { DialogsModule } from '@progress/kendo-angular-dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientHeaderComponent } from './patient-header.component';
import { PatientHeaderConfigurableComponent } from './patient-header-configurable/patient-header-configurable.component';
import { PatientEditModule } from '../patient-edit/patient-edit.module';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../pipes/pipes.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { CollapsibleModule } from '../collapsible/collapsible.module';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { MemberSendSelectionModule } from '../member-send-selection/member-send-selection.module';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { MemberSearchModule } from 'src/app/shared/member-search/member-search.module';
import { HouseholdModule } from 'src/app/household/household.module';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { PatientEligibilityModule } from '../patient-eligibility/patient-eligibility.module';

@NgModule({
  declarations: [
    PatientHeaderComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    PatientEditModule,
    PipesModule,
    DropDownsModule,
    FormsModule,
    DialogsModule,
    ButtonsModule,
    CollapsibleModule,
    InputsModule,
    MemberSendSelectionModule,
    TooltipsModule,
    HouseholdModule,
    MemberSearchModule,
    ContextMenuModule,
    PatientEligibilityModule,
    PatientHeaderConfigurableComponent
  ],
  exports: [
    PatientHeaderComponent,
    PatientHeaderConfigurableComponent
  ]
})
export class PatientHeaderModule { }
